export const AGENTS = {
  agent_1: { name: 'Tech Support - Slot 1', role: 'Tech Support', department: 'Tech Support', slot: 1 },
  agent_2: { name: 'Tech Support - Slot 2', role: 'Tech Support', department: 'Tech Support', slot: 2 },
  agent_3: { name: 'Customer Support - Slot 1', role: 'Customer Support', department: 'Customer Support', slot: 1 },
  agent_4: { name: 'Sales - Slot 1', role: 'Sales', department: 'Sales', slot: 1 },
  agent_5: { name: 'Sales - Slot 2', role: 'Sales', department: 'Sales', slot: 2 },
  web_user: { name: 'Web User', role: 'General' }
};

export const DEPARTMENT_LABELS = {
  tech: 'Tech Support',
  support: 'Customer Support',
  sales: 'Sales',
};

export const DEPARTMENT_OPTIONS = Object.entries(DEPARTMENT_LABELS).map(([value, label]) => ({
  value,
  label,
}));

export const buildDepartmentOptions = (departments = []) => {
  const byValue = new Map(DEPARTMENT_OPTIONS.map((option) => [option.value, option]));

  (Array.isArray(departments) ? departments : []).forEach((department) => {
    const value = String(department?.value || '').trim().toLowerCase();
    const label = String(department?.text || department?.label || '').trim();
    if (!value || department?.isActive === false) return;
    byValue.set(value, {
      value,
      label: label || DEPARTMENT_LABELS[value] || value,
      isDefault: Boolean(department?.isDefault),
      sortOrder: Number.isFinite(department?.sortOrder) ? department.sortOrder : 100,
    });
  });

  return Array.from(byValue.values()).sort((left, right) => {
    const leftOrder = Number.isFinite(left.sortOrder) ? left.sortOrder : 100;
    const rightOrder = Number.isFinite(right.sortOrder) ? right.sortOrder : 100;
    if (leftOrder !== rightOrder) return leftOrder - rightOrder;
    return left.label.localeCompare(right.label) || left.value.localeCompare(right.value);
  });
};

export const AGENT_SLOT_GROUPS = Object.entries(AGENTS).reduce((groups, [agentId, meta]) => {
  if (agentId === 'web_user' || !meta.department || !meta.slot) {
    return groups;
  }

  if (!groups[meta.department]) {
    groups[meta.department] = [];
  }

  groups[meta.department].push({
    agentId,
    label: `${meta.department} - Slot ${meta.slot} (${agentId})`,
  });

  return groups;
}, {});

export const formatAgentLabel = (agentId) => {
  const entry = AGENTS[agentId];
  if (!entry) return agentId;
  return entry.name;
};

export const getAgentMeta = (agentId) => {
  const entry = AGENTS[agentId];
  if (!entry) return { name: agentId, role: '' };
  return entry;
};

const formatDepartmentFallbackLabel = (department) => (
  String(department || '')
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase())
);

export const getDepartmentLabel = (department) => {
  const normalized = String(department || '').trim().toLowerCase();
  return DEPARTMENT_LABELS[normalized] || formatDepartmentFallbackLabel(normalized);
};

export const getDepartmentLabelFromOptions = (department, departments = []) => {
  const normalized = String(department || '').trim().toLowerCase();
  if (!normalized) return '';
  const options = buildDepartmentOptions(departments);
  return options.find((option) => option.value === normalized)?.label
    || DEPARTMENT_LABELS[normalized]
    || formatDepartmentFallbackLabel(normalized);
};
